module.exports = __webpack_public_path__ + "img/airbase-gallery-1.c36d2603.jpg";